import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import Swal from 'sweetalert2';
import { URL_DOCS } from 'src/app/config/config';
declare var $: any;

@Component({
  selector: 'app-admin-certificacion',
  templateUrl: './admin-certificacion.component.html',
  styleUrls: ['./admin-certificacion.component.css']
})
export class AdminCertificacionComponent implements OnInit {

  isEdit = false;
  isLoading = false;
  URL_DOCS = URL_DOCS;

  modalActivo: 'crear' | 'editar' | null = null;

  public listCustomers = [{ id: 0, name: '' }];

  public nuevaCert: any = {};
  public certSelected: any = {};

  numeros: number[] = Array.from({ length: 10 }, (_, i) => i);

  erroresCert: { [key: string]: boolean } = {};

  public certImageFile: File | null = null;
  public certImagePreview: string | null = null;

  selectedCustomerId: number | null = null;

  certsAll: any[] = [];
  certsFiltered: any[] = [];

  includeGlobals = true;

  constructor(
    private customerService: CustomerService,
    private mantenedorService: MantenedorService
  ) { }

  ngOnInit(): void {
    this.getCustomers();
    this.getCertifications();
  }

  // =========================
  // Filtro
  // =========================
  applyFilter(): void {
    if (!this.selectedCustomerId) {
      this.certsFiltered = [...this.certsAll];
      return;
    }

    this.certsFiltered = this.certsAll.filter(cert => {
      const isCustomer = Number(cert?.b2b_id_customer) === Number(this.selectedCustomerId);
      const isGlobal = cert?.is_global === true;
      return isCustomer || (this.includeGlobals && isGlobal);
    });
  }

  // =========================
  // Guardar (insert/update)
  // =========================
  async saveCert(accion: 'insert' | 'update') {
    this.isLoading = true;

    const objeto = accion === 'insert' ? this.nuevaCert : this.certSelected;
    if (!this.validarCamposObligatorios(objeto, accion)) {
      this.isLoading = false;
      return;
    }

    let dataSend: any = {};

    if (accion === 'update') {
      // regla popup vs tranversal
      if (this.certSelected.is_popup && this.certSelected.is_tranversal) {
        this.certSelected.is_tranversal = false;
      }

      // normalización scope
      if (this.certSelected.is_global) {
        this.certSelected.b2b_id_customer = null;
      }

      // normalización fechas (en tu html usas starts_at2 / ends_at2 en editar)
      if (this.certSelected.starts_at2) this.certSelected.starts_at = this.certSelected.starts_at2;
      if (this.certSelected.ends_at2 !== undefined) this.certSelected.ends_at = this.certSelected.ends_at2;

      dataSend = this.certSelected;

    } else if (accion === 'insert') {
      if (this.nuevaCert.is_popup && this.nuevaCert.is_tranversal) {
        this.nuevaCert.is_tranversal = false;
      }

      if (this.nuevaCert.is_global) {
        this.nuevaCert.b2b_id_customer = null;
      }

      dataSend = this.nuevaCert;
    }
    
    this.mantenedorService.postUpdateCertificationsCustomer(dataSend, accion)
      .then((resp: any) => {
        const id = resp['id'];        // cer_id
        const estado = resp['status']; // success | failed

        if (this.certImageFile && id) {
          this.mantenedorService.uploadCertificationImage(id, this.certImageFile)
            .then(() => {
              this.finalizarGuardado(accion, id, estado);
            })
            .catch(err => {
              console.error('Error al subir imagen:', err);
              this.finalizarGuardado(accion, id, estado);
            });
        } else {
          this.finalizarGuardado(accion, id, estado);
        }
      })
      .catch(err => {
        console.error('Error al actualizar:', err);
        Swal.fire('Error', 'No se pudo guardar la certificación.', 'error');
      })
      .finally(() => {
        this.isLoading = false;
      });
      
  }

  validarCamposObligatorios(obj: any, accion: 'insert' | 'update'): boolean {
    console.log('validarCamposObligatorios');
    this.erroresCert = {};

    // obligatorios base
    if (!obj.title || !obj.description) {
      Swal.fire('Faltan datos obligatorios', 'Debes completar: título, descripción', 'warning');
      this.erroresCert.title = !obj.title;
      this.erroresCert.description = !obj.description;
      //this.erroresCert.starts_at = !(obj.starts_at || obj.starts_at2);
      //this.erroresCert.starts_at2 = !(obj.starts_at || obj.starts_at2);
      return false;
    }

    // scope: si no es global debe haber cliente
    const isGlobal = !!obj.is_global;
    const customerId = obj.b2b_id_customer ?? obj.client_id; // por si reutilizas client_id
    if (!isGlobal && (!customerId || Number(customerId) <= 0)) {
      this.erroresCert.b2b_id_customer = true;
      Swal.fire('Falta cliente', 'Si no es global, debes seleccionar un cliente.', 'warning');
      return false;
    }

    /*
    // fechas: ends_at > starts_at (si viene)
    const start = obj.starts_at2 || obj.starts_at;
    const end = obj.ends_at2 || obj.ends_at;

    if (start && end) {
      const s = new Date(start);
      const e = new Date(end);
      if (e.getTime() <= s.getTime()) {
        this.erroresCert.ends_at = true;
        this.erroresCert.ends_at2 = true;
        Swal.fire('Fechas inválidas', 'La fecha de fin no puede ser menor o igual a la de inicio.', 'warning');
        return false;
      }
    }
    */

    // regla popup vs tranversal
    if (obj.is_popup && obj.is_tranversal) {
      Swal.fire('Regla inválida', 'No puede ser Popup y Pestaña Informativa al mismo tiempo.', 'warning');
      return false;
    }

    return true;
  }

  // =========================
  // Imagen
  // =========================
  public onCertImageSelected(event: any): void {
    const file: File | null = event?.target?.files?.length ? event.target.files[0] : null;

    this.certImageFile = file;
    this.erroresCert.image_file = !file;

    if (!file) {
      this.certImagePreview = null;
      return;
    }

    const reader = new FileReader();
    reader.onload = () => this.certImagePreview = String(reader.result);
    reader.readAsDataURL(file);
  }

  clearSelectedCertImage(): void {
    this.certImageFile = null;
    this.certImagePreview = null;
    this.erroresCert.image_file = false;
  }

  // =========================
  // Finalizar guardado
  // =========================
  finalizarGuardado(accion: 'insert' | 'update', id?: number, estado?: string): void {

    if (accion === 'insert') {
      if (estado === 'success') {
        Swal.fire('Guardado exitoso', '', 'success');
        ($('#crearCertificacion') as any).modal('hide');
        this.getCertifications();
      } else if (estado === 'failed') {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo crear la certificación.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
      }
    } else if (accion === 'update') {
      if (estado === 'success') {
        Swal.fire('Modificación exitosa', '', 'success');
        this.isEdit = false;
        ($('#editarCertificacion') as any).modal('hide');
      } else if (estado === 'failed') {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo actualizar la certificación.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
      }
    }
  }

  // =========================
  // Cargar clientes + certs
  // =========================
  async getCustomers() {
    await this.customerService.getListCustomer().then((data: any) => {
      this.listCustomers = data.datos.data;
    })
      .catch((error: any) => { console.log(error); })
      .finally(() => { this.isLoading = false; });
  }

  async getCertifications() {
    this.isLoading = true;

    
    await this.mantenedorService.getCertifications().then((data: any) => {
      this.certsAll = (data.data || []).map((x: any) => this.mapCertForUI(x));
      this.certsFiltered = [...this.certsAll];
      this.applyFilter();
    })
      .catch((error: any) => { console.log(error); })
      .finally(() => { this.isLoading = false; });
      
  }

  // =========================
  // Map para tabla + modal editar
  // =========================
  mapCertForUI(cert: any): any {
    const desde = cert?.starts_at ? this.toDateInput(cert.starts_at) : null;
    const hasta = cert?.ends_at ? this.toDateInput(cert.ends_at) : null;

    return {
      ...cert,
      desdeFormat: desde || '-',
      hastaFormat: hasta || 'Sin fin',
      starts_at2: desde,
      ends_at2: hasta,
    };
  }

  toDateInput(value: any): string | null {
    if (!value) return null;
    const s = String(value);
    // si viene timestamp ISO o similar, recorta
    return s.length >= 10 ? s.slice(0, 10) : s;
  }

  // =========================
  // Click / cancelar
  // =========================
  clickCert(cert: any) {
    this.certSelected = { ...cert };
    this.modalActivo = 'editar';
    this.isEdit = false;
    this.clearSelectedCertImage();
  }

  openCrearCert() {
    this.modalActivo = 'crear';
    this.isEdit = true;
    this.erroresCert = {};
    this.clearSelectedCertImage();

    this.nuevaCert = {
      is_active: false,
      is_popup: false,
      is_tranversal: false,
      is_global: false,
      b2b_id_customer: null,
      title: '',
      description: '',
      image_url: null,
      link_url: '',
      link_target: '_blank',
      starts_at: null,
      ends_at: null,
      priority: 0
    };
  }

  cancelEditCert(tipo: 'update' | 'insert') {
    if (tipo === 'update') {
      this.isEdit = false;
    }
  }

  // =========================
  // Toggles (crear)
  // =========================
  onTogglePopupCrearCert(): void {
    if (this.nuevaCert?.is_popup) {
      this.nuevaCert.is_tranversal = false;
    }
  }

  onToggleTransversalCrearCert(): void {
    if (this.nuevaCert?.is_tranversal) {
      this.nuevaCert.is_popup = false;
      this.nuevaCert.is_global = true;
      this.nuevaCert.b2b_id_customer = null;
    } else {
      this.nuevaCert.is_global = false;
    }
  }

  onToggleGlobalCrearCert(): void {
    if (this.nuevaCert?.is_tranversal) {
      this.nuevaCert.is_global = true;
      this.nuevaCert.b2b_id_customer = null;
      return;
    }

    if (this.nuevaCert?.is_global) {
      this.nuevaCert.b2b_id_customer = null;
    }
  }

  // =========================
  // Toggles (editar)
  // =========================
  onTogglePopupEditarCert(): void {
    if (this.certSelected?.is_popup) {
      this.certSelected.is_tranversal = false;
    }
  }

  onToggleTransversalEditarCert(): void {
    if (this.certSelected?.is_tranversal) {
      this.certSelected.is_popup = false;
      this.certSelected.is_global = true;
      this.certSelected.b2b_id_customer = null;
    } else {
      this.certSelected.is_global = false;
    }
  }

  onToggleGlobalEditarCert(): void {
    if (this.certSelected?.is_tranversal) {
      this.certSelected.is_global = true;
      this.certSelected.b2b_id_customer = null;
      return;
    }

    if (this.certSelected?.is_global) {
      this.certSelected.b2b_id_customer = null;
    }
  }

}
